import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Contact from "../pages/contact/page";
import Surveillance from "../pages/solutions/surveillance/page";
import RuggedComputing from "../pages/solutions/rugged-computing/page";
import DataProtection from "../pages/solutions/data-protection/page";
import SolutionsOverview from "../pages/solutions/page";
import Brands from "../pages/brands/page";
import Industries from "../pages/industries/page";
import CaseStudies from "../pages/case-studies/page";
import About from "../pages/about/page";
import HyteraBWV from "../pages/hytera-bwv/page";
import ArcfraSpotlight from "../pages/arcfra-spotlight/page";
import ArcfraAssessment from "../pages/arcfra-assessment/page";
import ExaGridSpotlight from "../pages/exagrid-spotlight/page";
import RuggedSpotlight from "../pages/rugged-spotlight/page";
import SearchPage from "../pages/search/page";
import VMwareAlternative from "../pages/vmware-alternative/page";
import BodyWornCamera from "../pages/body-worn-camera/page";
import RuggedTablet from "../pages/rugged-tablet/page";
import ExaGridBackup from "../pages/exagrid-backup/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/contact", element: <Contact /> },
  { path: "/solutions", element: <SolutionsOverview /> },
  { path: "/solutions/surveillance", element: <Surveillance /> },
  { path: "/solutions/rugged-computing", element: <RuggedComputing /> },
  { path: "/solutions/data-protection", element: <DataProtection /> },
  { path: "/brands", element: <Brands /> },
  { path: "/industries", element: <Industries /> },
  { path: "/case-studies", element: <CaseStudies /> },
  { path: "/about", element: <About /> },
  { path: "/hytera-bwv", element: <HyteraBWV /> },
  { path: "/arcfra-spotlight", element: <ArcfraSpotlight /> },
  { path: "/arcfra-assessment", element: <ArcfraAssessment /> },
  { path: "/exagrid-spotlight", element: <ExaGridSpotlight /> },
  { path: "/rugged-spotlight", element: <RuggedSpotlight /> },
  { path: "/search", element: <SearchPage /> },
  { path: "/vmware-alternative-malaysia", element: <VMwareAlternative /> },
  { path: "/body-worn-camera-malaysia", element: <BodyWornCamera /> },
  { path: "/rugged-tablet-malaysia", element: <RuggedTablet /> },
  { path: "/exagrid-backup-malaysia", element: <ExaGridBackup /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
